import { GameConfig } from './GameConfig';
import { Level } from './Level';
import { MarkovConfig, PathState } from './LevelConfig';

export class MarkovPathGenerator {
  public static getDefaultConfig(): MarkovConfig {
    return {
      initialState: PathState.EMPTY,
      transitionMatrix: {
        [PathState.EMPTY]: {
          [PathState.EMPTY]: 0.1,
          [PathState.COLLECTIBLE]: 0.1,
          [PathState.ENEMY]: 0.4,
          [PathState.OBSTACLE]: 0.4,
        },
        [PathState.COLLECTIBLE]: {
          [PathState.COLLECTIBLE]: 0.1,
          [PathState.EMPTY]: 0.7,
          [PathState.OBSTACLE]: 0.2,
        },
        [PathState.ENEMY]: {
          [PathState.EMPTY]: 0.5,
          [PathState.ENEMY]: 0.1,
          [PathState.OBSTACLE]: 0.3,
          [PathState.COLLECTIBLE]: 0.1, // Reward immediately after enemy
        },
        [PathState.OBSTACLE]: {
          [PathState.EMPTY]: 0.5,
          [PathState.COLLECTIBLE]: 0.2,
          [PathState.ENEMY]: 0.3,
        },
        [PathState.GAP]: {
          [PathState.EMPTY]: 1.0, // empty after gap
        },
        [PathState.CHECKPOINT]: {
          [PathState.EMPTY]: 1.0, // empty after checkpoint
        },
      },
    };
  }

  constructor(private level: Level) {}

  generate(): void {
    const markovConfig = this.level.config.markov;

    if (!markovConfig || !markovConfig.transitionMatrix || !markovConfig.initialState) {
      // If no Markov config exists, we just leave it as EMPTY
      // the other generators will use their internal probability system.
      return;
    }

    if (GameConfig.logDebug) {
      console.log(`[MarkovPathGenerator] Generating path states with initial state: ${markovConfig.initialState}`);
    }

    // Default initialization: pre-fill pathStates with EMPTY
    this.level.pathStates = new Array(this.level.pathPoints.length).fill(PathState.EMPTY);

    let currentState = markovConfig.initialState;
    this.level.pathStates[0] = currentState;

    for (let i = 1; i < this.level.pathPoints.length; i++) {
      const transitions = markovConfig.transitionMatrix[currentState];

      if (!transitions) {
        // Fallback to EMPTY if no transition is configured for the current state
        currentState = PathState.EMPTY;
      } else {
        // Pick the next state based on probabilities
        const randomValue = this.level.rng.uFloat32(); // 0.0 to 1.0
        let cumulativeProbability = 0;
        let nextState = PathState.EMPTY;

        for (const [stateStr, probability] of Object.entries(transitions)) {
          cumulativeProbability += probability as number;
          if (randomValue <= cumulativeProbability) {
            nextState = stateStr as PathState;
            break;
          }
        }

        currentState = nextState;
      }

      this.level.pathStates[i] = currentState;
    }

    if (GameConfig.logDebug) {
      console.log(`[MarkovPathGenerator] Path state generation complete.`);
    }
  }
}
